import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class DateValidatorService {
  constructor() {}

  private validateExpirationYear(date: string): boolean {
    const year = new Date(date).getFullYear();
    return year.toString().length <= 4;
  }

  validateAndCorrectExpirationDate(date: string): string {
    const inputDate = DateTime.fromISO(date);
    const now = DateTime.now();
    
    if (!inputDate.isValid) {
      return now.toISO();
    }

    if (!this.validateExpirationYear(date)) {
      return now.toISO();
    }

    if (inputDate < now) {
      return now.toISO();
    }

    return date;
  }

  handleExpirationDateChange(event: Event, currentValue: string): string {
    const input = event.target as HTMLInputElement;
    const newDate = input.value;
    
    const correctedDate = this.validateAndCorrectExpirationDate(newDate);
    
    if (correctedDate !== newDate) {
      input.value = correctedDate;
    }

    return correctedDate;
  }
}
